import React from "react";
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import axios from 'axios';

const TooltipIcon = ({ placement = "bottom", tooltip, iconClass, className = "", style = {} }) => (
  <OverlayTrigger
    placement={placement}
    delay={{ show: 250, hide: 400 }}
    overlay={<Tooltip className="tooltip-small">{tooltip}</Tooltip>}
  >
    <span className={`my-auto ${className}`}>
      <i
        className={iconClass}
        style={{ height: "20px", width: "20px", ...style }}
      ></i>
    </span>
  </OverlayTrigger>
);

const handleResetAttempts = async (resetAttemptsConfig, handleFetchTests) => {
  try {
    const response = await axios.put(
      resetAttemptsConfig.url,
      { appointment: { auth_attempts: 0 } },
    );

    if (response.data.success) {
      toastr.success("Attempts reset successfully");
      handleFetchTests();
    } else {
      toastr.error("Failed to reset attempts");
    }
  } catch (error) {
    toastr.error(`Something went wrong: ${error}`);
  }
};

const ActionIconsTableItem = ({ handleFetchTests, props }) => {
  const { notes, reset_attempts, case_report_url, test_edit_url } = props;
  const tooManyAuthAttempts = reset_attempts.too_many_auth_attempts;

  // Define a fixed width container style to ensure consistent alignment for icons
  const containerStyle = {
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-start',
    alignItems: 'center'
  };

  // Create a fixed position layout for icons
  const iconPositionStyle = {
    width: '24px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: '8px'
  };

  return (
    <div style={containerStyle}>
      <div style={iconPositionStyle}>
        {!!notes && (
          <TooltipIcon
            tooltip={notes}
            iconClass="fa-regular fa-note-sticky p-2"
          />
        )}
      </div>
      <div style={iconPositionStyle}>
        {tooManyAuthAttempts && (
          <TooltipIcon
            tooltip="Too many authentication attempts"
            iconClass="fa-solid fa-circle-exclamation text-danger p-2"
          />
        )}
      </div>
      <div className="dropdown">
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={<Tooltip className="tooltip-small">More actions</Tooltip>}
        >
          <a
            className="rounded-circle text-secondary pointer"
            id="dropdownMenuButton"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            style={{ cursor: 'pointer' }}
          >
            <i className="fa-regular p-2 fa-chevron-right" style={{ height: "20px", width: "20px" }}></i>
          </a>
        </OverlayTrigger>
        <ul
          className="dropdown-menu dropdown-menu-end"
          aria-labelledby="dropdownMenuButton"
        >
          <li>
            <a
              className={`dropdown-item ${tooManyAuthAttempts ? 'text-danger' : ''}`}
              href={reset_attempts.url}
              onClick={(e) => {
                e.preventDefault();
                handleResetAttempts(reset_attempts, handleFetchTests);
              }}
            >
              Reset attempts
            </a>
          </li>
          <li>
            <a
              className="dropdown-item"
              href={case_report_url}
            >
              View case report
            </a>
          </li>
          <li>
            <a
              className="dropdown-item"
              href={test_edit_url}
            >
              View order details
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default ActionIconsTableItem;